import { ChatMensaje, ChatMensajeTipo, ChatPerspectiva } from '../interfaces/chat.interface';

/** Tipo de mensaje que llega desde el otro lado del chat. */
export function chatTipoEntrante(perspectiva: ChatPerspectiva): ChatMensajeTipo {
  return perspectiva === 'admin' ? 'solicitud' : 'admin';
}

/** Resalta el chat cuando el ultimo mensaje es entrante y todavia no se abrio. */
export function chatNoLeido(
  mensajes: ChatMensaje[],
  tipoEntrante: ChatMensajeTipo = 'solicitud',
): boolean {
  const ultimo = mensajes.at(-1);
  return !!ultimo && !ultimo.leido && ultimo.tipo === tipoEntrante;
}

/** Devuelve el mismo array si no habia nada por marcar (evita renders al abrir un chat leido). */
export function chatMarcarLeidos(
  mensajes: ChatMensaje[],
  tipoEntrante: ChatMensajeTipo = 'solicitud',
): ChatMensaje[] {
  const pendiente = mensajes.some((mensaje) => !mensaje.leido && mensaje.tipo === tipoEntrante);
  if (!pendiente) {
    return mensajes;
  }

  return mensajes.map((mensaje) =>
    !mensaje.leido && mensaje.tipo === tipoEntrante ? { ...mensaje, leido: true } : mensaje,
  );
}
